import {
  Box,
  Button,
  Card,
  Divider,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { isValidElement } from 'react';

export default function ListToolbar({ actions, selectedRows }) {
  const selectedCount = selectedRows?.length;
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  actions = actions.map((action) => {
    let disabled = true;

    if (!action.selection || action.selection === 'none') {
      disabled = false;
    }
    if (action.selection === 'single' && selectedCount === 1) {
      disabled = false;
    }
    if (action.selection === 'multi' && selectedCount > 0) {
      disabled = false;
    }

    if (typeof action.disabled === 'boolean') {
      disabled = action.disabled;
    }

    return { ...action, disabled };
  });

  return (
    <Card
      sx={{
        py: 1,
        px: 2,
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        minHeight: '50px',
      }}
    >
      {actions.map((action, index) => {
        if (isValidElement(action)) return action;
        return (
          <Box
            key={action.title}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {action.group !== actions[index - 1]?.group && index !== 0 && (
              <Divider
                orientation="vertical"
                sx={{
                  height: '29px',
                  backgroundColor: 'rgba(0, 0, 0, 0.01)',
                  mr: 2,
                }}
              />
            )}
            <Tooltip title={action.title} enterDelay={500}>
              <span>
                <Button
                  variant={action.variant || 'text'}
                  color={action.color || 'primary'}
                  onClick={action.onClick}
                  sx={{
                    display: 'flex',
                    flexFlow: 'row',
                    alignItems: 'center',
                    px: 1.5,
                    minWidth: 0,
                    justifyContent: 'center',
                    ...((!action.variant || action.variant === 'text') && {
                      border: '1px solid transparent',
                    }),
                  }}
                  disabled={action.disabled}
                >
                  {action.icon && (
                    <action.icon sx={{ fontSize: '18px', mr: 0.5 }} />
                  )}
                  {action.label && (!sm || !action.icon) && (
                    <Typography sx={{ fontSize: 'inherit', lineHeight: 1 }}>
                      {action.label}
                    </Typography>
                  )}
                </Button>
              </span>
            </Tooltip>
          </Box>
        );
      })}
    </Card>
  );
}
